/**
 * 上传相关 toast 中"展示前 N 个文件名"的统一截断格式。
 *
 * 抽出来是为了让 use-upload-with-rename-on-conflict 与
 * use-claw-image-toasts 在批量失败列表上保持完全一致的呈现：
 * 前 3 个用顿号拼接，超过则尾巴 "..."，整体前缀为 ": "。
 */
export const UPLOAD_ERROR_TOAST_MAX = 3;

export const truncateUploadErrorList = (list: string[]): string => {
  const preview = list.slice(0, UPLOAD_ERROR_TOAST_MAX).join('、');
  const hasMore = list.length > UPLOAD_ERROR_TOAST_MAX;
  return preview ? `: ${preview}${hasMore ? '...' : ''}` : '';
};
